import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            探索分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            选择您感兴趣的话题，开启家庭关系的学习之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className="ri-bookmark-line text-lg text-accent-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}